module.exports = __webpack_public_path__ + "static/img/nav2.de10f0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/index/nav2.png
// module id = YOe0
// module chunks = 1